import React from "react";
import { getMrclTextClassName, MrclTextSize, MrclTextTagStyle } from "../marcelTypography";

export type MrclTextProps = {
  size?: MrclTextSize;
  tagStyle?: MrclTextTagStyle;
  bold?: boolean;
  underline?: boolean;
  reversed?: boolean;
} & React.HTMLAttributes<HTMLElement>;

const MrclText = ({
  size = "m",
  tagStyle = "p",
  bold,
  underline,
  reversed,
  className,
  style,
  children,
  ...rest
}: MrclTextProps) => (
  <span
    className={[
      getMrclTextClassName(tagStyle, size, bold),
      reversed ? "mrcl-text-color-reversed" : "mrcl-text-color-default",
      className,
    ].filter(Boolean).join(" ")}
    style={{
      display: "inline-flex",
      alignItems: "center",
      textDecoration: underline ? "underline" : undefined,
      ...style,
    }}
    {...rest}
  >
    {children}
  </span>
);

export default MrclText;
